/**
 * Static data for CustomHubPage — service pillars, portfolio spotlight,
 * process timeline, industries served, resources, and value props.
 *
 * Extracted from CustomHubPage.jsx in the Feb 2026 P2 refactor. Kept in
 * a plain data module (no JSX) so it can be imported by any variant of
 * the Custom Hub landing page without dragging component code along.
 */
import {
  Building2, MapPin, Users, FileText, Award, Shield, Globe,
  HeadphonesIcon, Paintbrush, Settings, Wrench, CheckCircle,
} from 'lucide-react';

export const servicePillars = [
  {
    id: 'logo-mats',
    title: 'Custom Logo Mats',
    description: 'Indoor & outdoor branded mats for high-traffic environments and multi-location rollouts.',
    image: '/Assets/images/00_global/Navigation/02_Products/custom-solutions-thumbnail.jpg',
    href: '/custom/logo-mats',
    features: ['Indoor / Outdoor', 'High Traffic', 'Multi-location'],
  },
  {
    id: 'installations',
    title: 'Large-Scale Installations',
    description: 'Full-scope installation services for corporate offices, retail, stadiums, and institutions.',
    image: '/Assets/images/industries/corporate-offices.jpg',
    href: '/custom/installations',
    features: ['Corporate Offices', 'Retail Environments', 'Stadiums & Arenas'],
  },
  {
    id: 'design-consultation',
    title: 'Design & Consultation',
    description: 'Expert guidance on material selection, branding integration, and performance requirements.',
    image: '/Assets/images/00_global/Navigation/03_Solutions/feature_Solutions_Talk-with-an-expert.jpg',
    href: '/custom/consultation',
    features: ['Material Selection', 'Branding Integration', 'Performance Requirements'],
  },
];

export const featuredInstallations = [
  {
    id: 1,
    projectName: 'Aubuchon Hardware',
    industry: 'Retail',
    scope: 'Commercial flooring systems, durable retail-ready surfaces, and entry/transition solutions across multiple store locations.',
    image: '/Assets/images/case-studies/aubuchon-hardware-hero.jpg',
    href: '/custom/portfolio/aubuchon-hardware',
  },
  {
    id: 3,
    projectName: 'Sky Zone, Greenville SC',
    industry: 'Commercial',
    scope: 'Recycled Rubber flooring installation with commercial-grade adhesives and floor preparation for high-traffic entertainment facility.',
    image: '/Assets/images/case-studies/sky-zone-hero.jpg',
    href: '/custom/portfolio/sky-zone',
  },
];

export const processSteps = [
  { step: 1, title: 'Consultation',            description: 'Initial discovery to understand your vision, requirements, and timeline.',    icon: HeadphonesIcon },
  { step: 2, title: 'Design & Mockups',        description: 'Custom designs and visual mockups tailored to your brand specifications.',    icon: Paintbrush },
  { step: 3, title: 'Material Engineering',    description: 'Selection and engineering of optimal materials for your environment.',        icon: Settings },
  { step: 4, title: 'Production',              description: 'Precision manufacturing with rigorous quality control standards.',            icon: Wrench },
  { step: 5, title: 'Installation & Support',  description: 'Professional installation with ongoing maintenance support.',                 icon: CheckCircle },
];

export const industries = [
  { name: 'Corporate Offices',            icon: Building2, href: '/custom/portfolio?industry=corporate' },
  { name: 'Grocery & Convenience Stores', icon: MapPin,    href: '/custom/portfolio?industry=grocery' },
  { name: 'Retailers',                    icon: MapPin,    href: '/custom/portfolio?industry=retail' },
  { name: 'Hospitality Sector',           icon: Users,     href: '/custom/portfolio?industry=hospitality' },
  { name: 'Mass Merchandiser',            icon: Building2, href: '/custom/portfolio?industry=mass-merchandiser' },
  { name: 'Educational Institutions',     icon: FileText,  href: '/custom/portfolio?industry=education' },
  { name: 'Financial Institutions',       icon: Award,     href: '/custom/portfolio?industry=financial' },
  { name: 'Government',                   icon: Shield,    href: '/custom/portfolio?industry=government' },
  { name: 'Pharmacy & Drugstore',         icon: Shield,    href: '/custom/portfolio?industry=pharmacy' },
  { name: 'Specialty Stores',             icon: Globe,     href: '/custom/portfolio?industry=specialty' },
];

export const resources = [
  { title: 'Custom Solutions Brochure',   type: 'PDF', size: '2.4 MB', href: '#' },
  { title: 'Technical Specifications',    type: 'PDF', size: '1.8 MB', href: '#' },
  { title: 'Installation Guidelines',     type: 'PDF', size: '3.2 MB', href: '#' },
  { title: 'Artwork Requirements',        type: 'PDF', size: '1.1 MB', href: '#' },
  { title: 'Care & Maintenance Guide',    type: 'PDF', size: '980 KB', href: '#' },
];

export const whyPorticoPoints = [
  { title: '25+ Years Experience',      description: 'Decades of expertise in commercial flooring solutions' },
  { title: 'National Install Teams',    description: 'Coast-to-coast professional installation coverage' },
  { title: 'In-House Design Support',   description: 'Dedicated design team for custom solutions' },
  { title: 'Commercial-Grade Materials', description: 'Premium materials built for high-traffic environments' },
  { title: 'Multi-Location Rollouts',   description: 'Seamless execution across hundreds of locations' },
];
